import React from 'react'
import styled from '@emotion/styled';
import { Box,Grid } from '@mui/material';
import Heading from '../../Components/LockerMenu/component/Heading';
import Paragraph from '../../Components/LockerMenu/component/Paragraph';
import Slider from '../../Components/LockerMenu/component/Slider';

const Wrapper = styled(Box)`
    padding: 80px 0px;
`

const Roadmap = () => {
  return (
    <Wrapper>
            <Grid container style={{justifyContent:'center',textAlign:'center'}}>
                <Grid>
                    <Heading style={{ marginBottom: '20px'}}>Roadmap</Heading>
                    <Paragraph style={{opacity: '0.6',maxWidth: '600px', marginBottom: '50px',justifySelf: 'center'}}>Explore our vision for the future, from launching innovative features to expanding our marketplace globally.</Paragraph>
                </Grid>
            </Grid>
            <Slider/>
    </Wrapper>
  )
}

export default Roadmap